import React from "react";
import { Link } from "react-router-dom";
import "./ToolsSection.css";

function ExploreToolsPage() {
  return (
    <div className="dashboard1-wrapper">
      
      
      {/* Navbar */}
      <header className="dashboard1-navbar">
        <h1>
          <Link to="/" className="dashboard1-logo">RevampSpaces</Link>
        </h1>
      </header>
      
      
      {/* Explore Tools Section */}
      <section className="dashboard1-features">
        
        
        <h2>Explore Our Tools</h2>
        <div className="dashboard1-card-container">
          <div className="dashboard1-image-card">
            <div className="dashboard1-card-content">
              <h3>Revamp The Existing Place</h3>
              <p>Generate interior designs for your space from your space.</p>
              <Link to="/main" className="dashboard1-cta-button">Try Now</Link>
            </div>
            <div className="dashboard1-hover-image">
              <img src="/images/txt2img1.4.png" alt="Before" className="dashboard1-before" />
              <img src="/images/txt2img1.3.png" alt="After" className="dashboard1-after" />
            </div>
          </div>

          <div className="dashboard1-image-card">
            <div className="dashboard1-card-content">
              <h3>Select and Shop for Furnishings</h3>
              <p>Select parts of an image you want to make changes to try different furnishings on each object.</p>
              <Link to="/inpainting" className="dashboard1-cta-button">Try Now</Link>
            </div>
            <div className="dashboard1-hover-image">
              <img src="/images/txt2img1.4.png" alt="Before" className="dashboard1-before" />
              <img src="/images/txt2img1.3.png" alt="After" className="dashboard1-after" />
            </div>
          </div>
          
          <div className="dashboard1-image-card">
            <div className="dashboard1-card-content">
              <h3>Turn bare walls into beautiful homes—one piece at a time.</h3>
              <p>Edit and enhance existing interior images.</p>
              <Link to="/furnish" className="dashboard1-cta-button">Try Now</Link>
            </div>
            <div className="dashboard1-hover-image">
              <img src="/images/lr123456.jpg" alt="Before" className="dashboard1-before" />
              <img src="/images/livingr.png" alt="After" className="dashboard1-after" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ExploreToolsPage;
